
import styled from 'styled-components';


export const CategoryItem = styled.a`
    display: block;
    text-align: center;
    margin-bottom: 40px;
    position: relative;
    padding: 45px 20px 20px;
    border:1px solid #a9a9a9;
    &:hover {
        border-color:var(--main-color)
    }
    img{
        transition:.3s;
    }
    .category-item-title{
        padding: 10px 20px ;
        text-align: center;
        font-size: 18px;
        font-family: LucidaFaxBoldItalic;
        margin: 0;
        position: absolute;
        top: -22px;
        left: 50%;
        transform:translateX(-50%);
        max-width: max-content;
        z-index: 5;
        background:#fff;
        background:var(--main-color);
        transition:.2s;
    }
    &:hover .category-item-title{
        top: -35px;
        box-shadow:0  1px 5px 3px #ddd;
    }
    img:hover{
        transform: translateY(-10px);
    }
`;